/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const DRUG_FAMILY_DETAILS_DATA = 'DRUG_FAMILY_DETAILS_DATA';
export const CREATE_NEW_FLAG = 'CREATE_NEW_FLAG';
export const DETAILS_ERROR_MSGS = 'DETAILS_ERROR_MSGS';
export const TAB_VALUE = 'TAB_VALUE';
export const DRUG_SEQ_NUM = 'DRUG_SEQ_NUM';
export const SELECTED_DRUG_DATA = 'SELECTED_DRUG_DATA';
export const DRUG_SEARCH_LIST = 'DRUG_SEARCH_LIST';
export const DETAILS_FORM_VALUES = 'DETAILS_FORM_VALUES';
export const SEARCH_LEFT_TABLE_DATA = 'SEARCH_LEFT_TABLE_DATA';
export const RIGHT_TABLE_DATA = 'RIGHT_TABLE_DATA';
export const DELETED_DRUGS = 'DELETED_DRUGS';
export const DUP_NDC_DATA = 'DUP_NDC_DATA';
export const RESET_STORE = 'RESET_STORE';
export const DRUG_ROUTE_CODE_DROPDOWN = 'DRUG_ROUTE_CODE_DROPDOWN';
export const MARKET_BASKET_DATA = 'MARKET_BASKET_DATA';
export const CONTRACTS_DATA = 'CONTRACTS_DATA';
export const DISABLE_SAVE_CANCEL = 'DISABLE_SAVE_CANCEL';
export const SEARCH_DRUG_DETAIL = 'SEARCH_DRUG_DETAIL';
export const MAINTAIN_LEFT_TABLE_DATA = 'MAINTAIN_LEFT_TABLE_DATA';
export const MAINTAIN_RIGHT_TABLE_DATA = 'MAINTAIN_RIGHT_TABLE_DATA';
export const DRUG_FAMILY_ID_NEW = 'DRUG_FAMILY_ID_NEW';
export const ALL_MANUFACTURER_DATA = 'ALL_MANUFACTURER_DATA';
export const DETAIL_DRUG_TABLEDATA = 'DETAIL_DRUG_TABLEDATA';
export const DELETE_DRUG_FAMILY_DRUGS = 'DELETE_DRUG_FAMILY_DRUGS';
export const UPDATE_ACTION_BIT = 'UPDATE_ACTION_BIT';
export const MAINTAIN_FORM_ELEMENTS = 'MAINTAIN_FORM_ELEMENTS';
export const NEW_MFG = 'NEW_MFG';
export const DISPATCH_SEARCH_ELEMENTS = 'DISPATCH_SEARCH_ELEMENTS';
export const NEW_STC = 'NEW_STC';
export const VIEW_DRUG_DETAILS = 'VIEW_DRUG_DETAILS';
export const SHOW_ERROR_RESPONSES = 'SHOW_ERROR_RESPONSES';
export const SAVE_SUCCESS_RESPONSE = 'SAVE_SUCCESS_RESPONSE';
export const SAVE_CANCEL_BIT = 'SAVE_CANCEL_BIT';
export const ERROR_FIELD_LIST = 'ERROR_FIELD_LIST';
export const RESET_MAINTAIN_PAGE = 'RESET_MAINTAIN_PAGE';
export const DETAIL_SCREEN_ERROR = 'DETAIL_SCREEN_ERROR';
export const GET_NEW_MFG_ID = 'actionType.GET_NEW_MFG_ID';
